import '@/scss/mindarc-astro.scss'

import Vue from 'vue'

// Global components
import ProductAccordion from '../components/product-accordion.js'

Vue.component('ProductAccordion', ProductAccordion)
const initVueInstance = element => {
  return new Vue({
    el: element,

    delimiters: ['${', '}'],

    components: {
      ProductAccordion
    }
  })
}

const initVue = () => document.querySelectorAll('[vue-init]').forEach(element => {
  initVueInstance(element)
})

initVue()

// Fix for theme editor preview
document.addEventListener('shopify:section:load', (event) => {
  // Vue HTML tags disappear so it can't reinitialise, causing the header to break
  if (event.target.id.includes('megamenu')) return
  initVue()
})
